import type { TRuleWithTheme } from 'styles/theme';

export const container: TRuleWithTheme = ({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    padding: '0.75rem',
    borderRadius: '0.75rem',
    border: `1px solid ${theme.colors.borderColor}`,
    backgroundColor: theme.colors.white,
    boxShadow: '0 2px 10px rgba(0, 0, 0, 0.04)',
    transition: 'border-color 0.15s ease, box-shadow 0.15s ease',

    ':focus-within': {
        borderColor: theme.colors.primary,
        boxShadow: `0 2px 14px rgba(255, 91, 92, 0.14)`,
    },
});

export const textarea: TRuleWithTheme = () => ({
    '&.ant-input': {
        border: 'none',
        boxShadow: 'none',
        padding: '0.5rem 0.5rem 0',
        fontSize: '1.0625rem',
        resize: 'none',

        ':focus': {
            boxShadow: 'none',
        },
    },
});

export const footer: TRuleWithTheme = () => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    paddingTop: '0.5rem',
});

export const submitButton: TRuleWithTheme = () => ({
    display: 'flex',
    alignItems: 'center',
    gap: '0.375rem',
});

export const examples: TRuleWithTheme = () => ({
    display: 'flex',
    flexWrap: 'wrap',
    gap: '0.5rem',
    marginTop: '1rem',
});

export const exampleChip: TRuleWithTheme = ({ theme }) => ({
    cursor: 'pointer',
    padding: '0.375rem 0.75rem',
    borderRadius: '999px',
    border: `1px solid ${theme.colors.borderColor}`,
    backgroundColor: theme.colors.white,
    color: theme.colors.textGrey,
    fontSize: '0.8125rem',
    transition: 'border-color 0.15s ease, color 0.15s ease',

    ':hover': {
        borderColor: theme.colors.borderPrimaryHover,
        color: theme.colors.primary,
    },
});
